import { render, staticRenderFns } from "./cModalMovement.vue?vue&type=template&id=0c15b82e&scoped=true"
import script from "./cModalMovement.vue?vue&type=script&lang=js"
export * from "./cModalMovement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c15b82e",
  null
  
)

export default component.exports